import React from 'react';
import BaseTabPanel from '@material-ui/lab/TabPanel';

const TabPanel = (props) => <BaseTabPanel {...props} />;

export default TabPanel;
